import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const FourPointStarIcon = forwardRef((props, ref) => {
    return (jsx(SvgIcon, Object.assign({ fill: 'currentColor' }, props, { ref: ref }, { children: jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: 'inherit', height: 'inherit' }, { children: jsx("path", { d: "M15.693 7.576 13.4 6.919a6.283 6.283 0 0 1-4.337-4.347l-.656-2.3a.438.438 0 0 0-.81 0l-.656 2.3A6.283 6.283 0 0 1 2.6 6.919l-2.3.657a.422.422 0 0 0 0 .812l2.3.657a6.283 6.283 0 0 1 4.337 4.347l.656 2.3a.421.421 0 0 0 .81 0l.656-2.3A6.283 6.283 0 0 1 13.4 9.046l2.3-.657a.422.422 0 0 0 0-.812z" }) })) })));
});

export { FourPointStarIcon };
//# sourceMappingURL=FourPointStarIcon.js.map
